<style style="text/scss" lang="scss">
  .preloader-blank {
    background: white;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 1000;
    padding-top: 10px;
  }
</style>

<div class="preloader-blank"></div>
